import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailActu = () => {
  // Article SIMA 2025
  const article = {
    id: 1,
    title:
      "Le SIMA 2025 : Le rythme de la croissance - L'Expert-Comptable, l'architecte financier de l'industrie musicale africaine",
    excerpt:
      "Le Salon des Industries Musicales d'Afrique Francophone s'apprête à faire vibrer Cotonou du 10 au 15 novembre. Découvrez pourquoi cet événement représente une opportunité stratégique majeure pour les experts-comptables.",
    content: `
      <p class="lead"> Si cet événement est d'abord perçu comme une vitrine pour les talents et une plateforme de rencontres pour les acteurs du secteur, il est avant tout un forum économique majeur.</p>
      
      <p>Pour les experts-comptables, le SIMA 2025 n'est pas seulement un rendez-vous culturel, mais un terrain de jeu stratégique et une source d'opportunités sans précédent.</p>
      
      <p>L'industrie musicale africaine, avec ses revenus qui franchissent pour la première fois le cap des 100 millions de dollars, est en pleine mutation. Le thème du SIMA, « Du potentiel aux preuves : faire rayonner et financer les musiques d'Afrique francophone », souligne la transition essentielle de la passion à la professionnalisation. C'est précisément à ce carrefour que le professionnel du chiffre devient indispensable.</p>

      <h3>La structuration et le financement : un défi comptable</h3>
      
      <p>L'une des problématiques centrales du SIMA est le financement de l'industrie musicale en Afrique. De nombreux talents et producteurs peinent à transformer leur potentiel en entreprises viables et à attirer des investissements. C'est là que l'expert-comptable entre en scène.</p>
      
      <p><strong>Ses missions sont cruciales :</strong></p>
      
      <ul>
        <li><strong>Conseil en création d'entreprise :</strong> aider les artistes, labels et producteurs à choisir la structure juridique adaptée (entreprise individuelle, SARL, SA) pour professionnaliser leur activité.</li>
        <li><strong>Établissement de business plans :</strong> fournir la rigueur financière nécessaire à la levée de fonds auprès des bailleurs et institutions attendus au salon.</li>
        <li><strong>Gestion et conformité :</strong> accompagner ces entreprises naissantes dans la tenue de leur comptabilité, la gestion de leur trésorerie et la mise en place de procédures de contrôle interne, garantissant ainsi la transparence et la crédibilité.</li>
      </ul>
      
      <p>En participant au SIMA, l'expert-comptable se positionne comme le partenaire clé pour transformer un projet artistique en un modèle économique durable et bancable.</p>

      <h3>La propriété intellectuelle et les données : une nouvelle expertise</h3>
      
      <p>L'industrie musicale moderne est de plus en plus basée sur les actifs immatériels. La propriété intellectuelle, les redevances de streaming et les droits d'auteur sont désormais les principales sources de revenus. Ces actifs, souvent complexes à valoriser et à gérer, représentent un nouveau champ d'action pour l'expert-comptable.</p>
      
      <p>Au SIMA, où l'importance de la data et de la propriété intellectuelle est au cœur des débats, le professionnel du chiffre peut offrir son expertise pour :</p>
      
      <ul>
        <li><strong>Valoriser les catalogues musicaux :</strong> aider les labels à estimer la valeur réelle de leurs droits d'auteur et de leurs enregistrements.</li>
        <li><strong>Optimiser la gestion des redevances :</strong> mettre en place des systèmes de suivi et de comptabilisation des revenus de streaming, des droits de licence et des revenus générés par les concerts (live).</li>
        <li><strong>Conseiller sur les aspects fiscaux</strong> de ces flux de revenus internationaux.</li>
      </ul>

      <h3>Un écosystème en pleine croissance : l'opportunité d'une nouvelle clientèle</h3>
      
      <p>Le SIMA rassemble plus de 7 000 participants, des artistes émergents aux managers, en passant par des startups, des promoteurs et des investisseurs. Chacun de ces acteurs représente un client potentiel pour un cabinet d'expertise comptable spécialisé.</p>
      
      <p>L'expert-comptable a l'occasion de rencontrer une nouvelle clientèle aux besoins spécifiques :</p>
      
      <ul>
        <li><strong>Les artistes</strong> ont besoin d'aide pour gérer leurs finances personnelles, leurs contrats et leurs tournées.</li>
        <li><strong>Les producteurs et les labels</strong> recherchent des partenaires pour la gestion quotidienne de leur entreprise et l'établissement de prévisions financières.</li>
        <li><strong>Les startups culturelles</strong> ont besoin d'être accompagnées pour leurs levées de fonds.</li>
      </ul>
      
      <blockquote>
        "Le SIMA n'est donc pas qu'un salon de la musique, c'est aussi un rendez-vous d'affaires où l'avenir de l'économie créative africaine est en jeu."
      </blockquote>
      
      <p>Pour les experts-comptables, y participer est la meilleure façon de se positionner comme un acteur essentiel de cette transformation, capable d'apporter la rigueur et la stratégie financière nécessaires pour que la musique d'Afrique francophone devienne un véritable moteur de développement.</p>
      
      <p><strong>Pour en savoir plus :</strong> <a href="https://simaonline.net/" target="_blank" rel="noopener noreferrer">https://simaonline.net/</a></p>
    `,
    image: "/assets/images/image29.jpg",
    category: "Événements",
    date: "24 septembre 2025",
    author: "Wilfrid DEDJI",
    readTime: "8 min",
    tags: [
      "SIMA",
      "Industrie Musicale",
      "Expertise Comptable",
      "Afrique",
      "Financement",
      "Cotonou",
    ],
  };

  return (
    <>
      <Header />
      <div className="article-content py-5">
        <div className="container">
          {/* Fil d'Ariane */}
          <nav className="breadcrumb-container mb-4">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none">
                  Accueil
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/actualites" className="text-decoration-none">
                  Actualités
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {article.title}
              </li>
            </ol>
          </nav>

          <div className="row">
            <div className="col-lg-8">
              {/* Catégorie et Titre */}
              <div className="article-header mb-4">
                <span className="category-badge">{article.category}</span>
                <h1 className="article-title mt-3">{article.title}</h1>
                {/* Métadonnées de l'article */}
                <div className="article-meta d-flex align-items-center mt-3">
                  <div className="meta-item d-flex align-items-center">
                    <FaCalendarAlt className="meta-icon" />
                    <span>{article.date}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaUser className="meta-icon" />
                    <span>{article.author}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaClock className="meta-icon" />
                    <span>{article.readTime} de lecture</span>
                  </div>
                </div>
              </div>

              {/* Image principale */}
              <div className="article-featured-image mb-4">
                <img
                  src="../assets/images/image29.jpg"
                  alt={article.title}
                  className="img-fluid rounded"
                />
              </div>

              {/* Extrait de l'article */}
              <div className="article-excerpt mb-4">
                <p className="lead">{article.excerpt}</p>
              </div>

              {/* Contenu principal */}
              <div
                className="article-body mb-5"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />

              {/* Tags */}
              <div className="article-tags mb-4">
                {article.tags.map((tag, index) => (
                  <Link key={index} to={``} className="article-tag">
                    #{tag}
                  </Link>
                ))}
              </div>

              {/* Partage sur les réseaux sociaux */}
              <div className="article-share mb-5">
                <h5 className="share-title">Partager cet article</h5>
                <div className="social-buttons">
                  <a href="#" className="social-button linkedin">
                    <FaLinkedin />
                  </a>
                  <a href="#" className="social-button twitter">
                    <FaTwitter />
                  </a>
                  <a href="#" className="social-button facebook">
                    <FaFacebook />
                  </a>
                </div>
              </div>

              {/* Bouton Retour */}
              <div className="article-actions mb-5">
                <Link to="/actualites" className="btn btn-back">
                  <FaChevronLeft className="me-2" /> Retour aux actualités
                </Link>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              {/* À propos de l'auteur */}
              <div className="sidebar-widget author-widget">
                <h4 className="widget-title">À propos de l'auteur</h4>
                <div className="author-profile">
                  <div className="author-image">
                    <img
                      src="../assets/images/image3.png"
                      alt={article.author}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                  <div className="author-info">
                    <h5 className="author-name">{article.author}</h5>
                    <p className="author-bio">
                      Expert-Comptable spécialisé dans l'accompagnement des
                      entreprises et des secteurs créatifs en Afrique
                      francophone.
                    </p>
                  </div>
                </div>
              </div>

              {/* Widget Newsletter */}
              <div className="sidebar-widget newsletter-widget">
                <h4 className="widget-title">Newsletter</h4>
                <p className="newsletter-desc">
                  Restez informé des dernières actualités fiscales et comptables
                </p>
                <form className="newsletter-form">
                  <div className="form-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Votre adresse email"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    S'abonner
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        /* Import des polices Google */
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Playfair+Display:wght@700;800&display=swap');

        /* Variables CSS */
        :root {
          --color-primary-red: #dc3545;
          --color-primary-green: #198754;
          --color-dark: #1a1a1a;
          --color-gray-dark: #4a4a4a;
          --color-gray: #6c757d;
          --color-gray-light: #e9ecef;
          --color-white: #ffffff;
          --font-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          --font-heading: 'Playfair Display', Georgia, serif;
          --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.06);
          --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.08);
          --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.12);
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        /* Styles généraux */
        .article-content {
          background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
          font-family: var(--font-primary);
          color: var(--color-dark);
        }

        /* Fil d'Ariane */
        .breadcrumb-container {
          padding: 1rem 0;
        }

        .breadcrumb {
          background-color: transparent;
          padding: 0;
          margin-bottom: 0;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: var(--color-gray);
          content: "›";
          font-size: 1.2rem;
        }

        .breadcrumb-item a {
          color: var(--color-gray);
          text-decoration: none;
          transition: var(--transition);
        }

        .breadcrumb-item a:hover {
          color: var(--color-primary-red);
        }

        .breadcrumb-item.active {
          color: var(--color-dark);
          font-weight: 600;
        }

        /* En-tête de l'article */
        .article-header {
          margin-bottom: 2.5rem;
        }

        .article-title {
          font-family: var(--font-heading);
          font-size: 2rem;
          font-weight: 800;
          line-height: 1.2;
          margin-top: 1rem;
          margin-bottom: 1.5rem;
          color: var(--color-dark);
          letter-spacing: -0.02em;
        }

        .category-badge {
          display: inline-block;
          background: linear-gradient(135deg, var(--color-primary-red) 0%, var(--color-primary-green) 100%);
          color: white;
          padding: 0.5rem 1.25rem;
          border-radius: 50px;
          font-size: 0.813rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          box-shadow: 0 4px 12px rgba(220, 53, 69, 0.25);
        }

        .article-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
          padding: 1rem 0;
          border-top: 1px solid var(--color-gray-light);
          border-bottom: 1px solid var(--color-gray-light);
        }

        .meta-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: var(--color-gray-dark);
          font-size: 0.875rem;
          font-weight: 500;
        }

        .meta-icon {
          color: var(--color-primary-red);
          font-size: 1rem;
        }

        /* Image principale */
        .article-featured-image {
          border-radius: 16px;
          overflow: hidden;
          box-shadow: var(--shadow-lg);
          margin-bottom: 2.5rem;
          position: relative;
          height: 450px;
          width: 100%;
        }

        .article-featured-image::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.05) 100%);
          pointer-events: none;
        }

        .article-featured-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        .article-featured-image:hover img {
          transform: scale(1.02);
        }

        /* Extrait */
        .article-excerpt {
          background: linear-gradient(135deg, rgba(220, 53, 69, 0.05) 0%, rgba(25, 135, 84, 0.05) 100%);
          border-left: 4px solid var(--color-primary-red);
          padding: 1.5rem 2rem;
          border-radius: 0 12px 12px 0;
          margin-bottom: 2.5rem;
        }

        .article-excerpt .lead {
          font-size: 1.25rem;
          font-weight: 400;
          line-height: 1.7;
          color: var(--color-gray-dark);
          margin-bottom: 0;
        }

        /* Contenu de l'article */
        .article-body {
          font-size: 1.063rem;
          line-height: 1.8;
          color: var(--color-dark);
          text-align: justify;
        }

        .article-body h3 {
          font-family: var(--font-heading);
          font-size: 1.75rem;
          font-weight: 700;
          color: var(--color-dark);
          margin-top: 2.5rem;
          margin-bottom: 1.25rem;
          padding-bottom: 0.75rem;
          border-bottom: 3px solid transparent;
          border-image: linear-gradient(to right, var(--color-primary-red), var(--color-primary-green)) 1;
          letter-spacing: -0.01em;
        }

        .article-body p {
          margin-bottom: 1.5rem;
        }

        .article-body ul {
          margin: 1.5rem 0;
          padding-left: 0;
          list-style: none;
        }

        .article-body li {
          margin-bottom: 1.25rem;
          padding-left: 2rem;
          position: relative;
          line-height: 1.7;
        }

        .article-body li::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0.6rem;
          width: 8px;
          height: 8px;
          background: linear-gradient(135deg, var(--color-primary-red), var(--color-primary-green));
          border-radius: 50%;
        }

        .article-body strong {
          color: var(--color-dark);
          font-weight: 700;
        }

        .article-body blockquote {
          background: linear-gradient(135deg, rgba(220, 53, 69, 0.08) 0%, rgba(25, 135, 84, 0.08) 100%);
          border-left: 4px solid var(--color-primary-green);
          padding: 1.5rem 2rem;
          margin: 2.5rem 0;
          border-radius: 0 12px 12px 0;
          font-style: italic;
          font-size: 1.125rem;
          color: var(--color-gray-dark);
          box-shadow: var(--shadow-sm);
        }

        .article-body a {
          color: var(--color-primary-red);
          text-decoration: none;
          font-weight: 600;
          border-bottom: 2px solid transparent;
          transition: var(--transition);
        }

        .article-body a:hover {
          border-bottom-color: var(--color-primary-red);
        }

        /* Tags */
        .article-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-top: 2rem;
          padding: 1.5rem;
          background: linear-gradient(135deg, rgba(220, 53, 69, 0.03) 0%, rgba(25, 135, 84, 0.03) 100%);
          border-radius: 12px;
        }

        .article-tag {
          display: inline-block;
          background: white;
          color: var(--color-gray-dark);
          padding: 0.5rem 1rem;
          border-radius: 50px;
          text-decoration: none;
          font-size: 0.875rem;
          font-weight: 600;
          transition: var(--transition);
          border: 2px solid var(--color-gray-light);
          box-shadow: var(--shadow-sm);
        }

        .article-tag:hover {
          background: linear-gradient(135deg, var(--color-primary-red), var(--color-primary-green));
          color: white;
          border-color: transparent;
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }

        /* Partage social */
        .article-share {
          margin-top: 3rem;
          padding: 2rem;
          background: linear-gradient(135deg, rgba(220, 53, 69, 0.03) 0%, rgba(25, 135, 84, 0.03) 100%);
          border-radius: 12px;
          border: 1px solid var(--color-gray-light);
        }

        .share-title {
          font-size: 1rem;
          font-weight: 700;
          margin-bottom: 1.25rem;
          color: var(--color-dark);
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .social-buttons {
          display: flex;
          gap: 1rem;
        }

        .social-button {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: var(--transition);
          box-shadow: var(--shadow-sm);
          font-size: 1.25rem;
        }

        .social-button:hover {
          transform: translateY(-4px);
          box-shadow: var(--shadow-md);
        }

        .linkedin {
          background: linear-gradient(135deg, #0077b5 0%, #005885 100%);
        }

        .twitter {
          background: linear-gradient(135deg, #1da1f2 0%, #0d8bd9 100%);
        }

        .facebook {
          background: linear-gradient(135deg, #4267b2 0%, #2d4373 100%);
        }

        /* Bouton retour */
        .btn-back {
          display: inline-flex;
          align-items: center;
          background: white;
          color: var(--color-gray-dark);
          padding: 0.875rem 1.75rem;
          border-radius: 50px;
          text-decoration: none;
          box-shadow: var(--shadow-sm);
          transition: var(--transition);
          font-weight: 600;
          font-size: 0.938rem;
          border: 2px solid var(--color-gray-light);
        }

        .btn-back:hover {
          background: var(--color-primary-red);
          color: white;
          border-color: var(--color-primary-red);
          transform: translateX(-8px);
          box-shadow: var(--shadow-md);
        }

        /* Sidebar Widgets */
        .sidebar-widget {
          background: white;
          border-radius: 16px;
          padding: 2rem;
          margin-bottom: 2rem;
          box-shadow: var(--shadow-md);
          border: 1px solid rgba(0, 0, 0, 0.04);
          transition: var(--transition);
        }

        .sidebar-widget:hover {
          box-shadow: var(--shadow-lg);
        }

        .widget-title {
          font-family: var(--font-heading);
          font-size: 1.375rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid var(--color-gray-light);
          position: relative;
          color: var(--color-dark);
        }

        .widget-title::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 60px;
          height: 3px;
          background: linear-gradient(to right, var(--color-primary-red), var(--color-primary-green));
          border-radius: 2px;
        }

        /* Widget Auteur */
        .author-profile {
          text-align: center;
        }

        .author-image {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 auto 1rem;
          border: 4px solid transparent;
          background: linear-gradient(white, white) padding-box,
                      linear-gradient(135deg, var(--color-primary-red), var(--color-primary-green)) border-box;
          box-shadow: var(--shadow-sm);
        }

        .author-name {
          font-size: 1.125rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: var(--color-dark);
        }

        .author-bio {
          font-size: 0.875rem;
          color: var(--color-gray);
          line-height: 1.6;
          margin-bottom: 0;
        }

        /* Widget Newsletter */
        .newsletter-widget {
          background: linear-gradient(135deg, rgba(220, 53, 69, 0.05) 0%, rgba(25, 135, 84, 0.05) 100%);
        }

        .newsletter-desc {
          margin-bottom: 1.25rem;
          color: var(--color-gray-dark);
          font-size: 0.875rem;
          line-height: 1.6;
        }

        .newsletter-form .form-control {
          padding: 0.875rem 1.25rem;
          border: 2px solid var(--color-gray-light);
          border-radius: 50px;
          font-size: 0.938rem;
          transition: var(--transition);
        }

        .newsletter-form .form-control:focus {
          border-color: var(--color-primary-red);
          outline: none;
          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
        }

        .btn-primary {
          background: linear-gradient(135deg, var(--color-primary-red) 0%, var(--color-primary-green) 100%);
          border: none;
          border-radius: 50px;
          padding: 0.875rem 1.5rem;
          font-weight: 600;
          font-size: 0.938rem;
          transition: var(--transition);
          box-shadow: 0 4px 12px rgba(220, 53, 69, 0.25);
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(220, 53, 69, 0.35);
        }

        /* Responsive */
        @media (max-width: 992px) {
          .article-title {
            font-size: 2.25rem;
          }

          .article-featured-image {
            height: 350px;
          }
        }

        @media (max-width: 768px) {
          .article-title {
            font-size: 1.875rem;
          }

          .article-featured-image {
            height: 280px;
          }

          .article-meta {
            flex-wrap: wrap;
            gap: 1rem;
          }

          .article-body {
            font-size: 1rem;
          }

          .article-body h3 {
            font-size: 1.5rem;
          }
        }
      `}</style>
    </>
  );
};

export default DetailActu;